export const iconStyles = {
  fontSize: '1.3rem',
  opacity: '80%',
  cursor: 'pointer',
  transition: 'all ease 0.1s',
  '&:hover': {
    opacity: '100%',
  },
};
